import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../element'

export const Button = ({ label, action, isI18n, ...props }) => {
  return (
    <Element elementName="button" {...props} onClick={action}>
      {isI18n ? <Translate value={label} /> : label}
    </Element>
  )
}

Button.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  action: PropTypes.func,
  isI18n: PropTypes.bool,
}

Button.defaultProps = {
  action: () => {},
  isI18n: false,
}
